import Documento from "@/models/Documento";
import Profissional from "../models/Profissional";

export default class RelatorioInspecao {
  constructor() {
    this.numero = "";
    this.data = new Date();
    this.material = "Poliéster";
    this.resultado = "APROVADO";
    this.observacao = "";
    this.documento = new Documento();
    this.inspetor = new Profissional();
  }

  update(ri) {
    this.numero = ri.numero;
    this.data = ri.data;
    this.material = ri.material;
    this.resultado = ri.resultado;
    this.observacao = ri.observacao;
    this.documento = ri.documento;
    this.inspetor = ri.inspetor;
  }
}
